import dot from 'dot-prop-immutable';
import { assocPath } from 'ramda';

import { PAGE_SUCCESS } from '../app/actions';
import * as types from './types';

const initialState = {
  accessToken: null,
  isFetching: false,
  isSupplierTaxRateFetching: false,
  paperlessTerms: [],
  user: null,
};

export default function auth(state = initialState, action) {
  const { payload } = action;
  switch (action.type) {
    case PAGE_SUCCESS:
      return { ...state, error: null, success: null, isFetching: null };
    case types.RECEIVE_ACCESS_TOKEN:
      return {
        ...state,
        accessToken: action.payload.accessToken,
      };
    case types.RECEIVE_USER:
      return {
        ...state,
        user: action.payload,
      };
    /* PROFILE STUFF -- TO BE MOVED TO SUPPLIER MODULE */
    case types.UPDATE_CONNECTED_ACCOUNT_SUCCESS:
      return assocPath(
        ['user', 'group', 'banking_information'],
        payload.banking_information,
        state,
      );
    case types.PAPERLESS_TERMS:
      return {
        ...state,
        paperlessTerms: payload.paperlessTerms,
      };
    case types.RECEIVE_GROUP:
      return dot.merge(state, 'user.group', payload);
    default:
      return state;
  }
}
